import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

function pinGeneralContent() {
  const headerElement = document.querySelector('.js-header')
  const viewportHeight = window.innerHeight
  const headerHeight = headerElement.offsetHeight
  const viewportHeightMinusHeaderHeight = viewportHeight - headerHeight
  const pinnedGeneralContentHeight =
    (viewportHeightMinusHeaderHeight / viewportHeight) * 100

  const pinnedGeneralContentElements = gsap.utils.toArray(
    '.js-general-content-pinned'
  )

  pinnedGeneralContentElements.forEach(elem => {
    const generalContentSection = elem.parentElement
    const generalContentRow = elem.querySelector('.js-general-content-row')

    generalContentSection.setAttribute(
      'style',
      'padding:0; height: calc(' + pinnedGeneralContentHeight + 'vh - 80px);'
    )

    gsap.to(elem, {
      duration: 0.5,
      autoAlpha: 1,
    })

    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: generalContentSection,
        start: 'top ' + headerHeight + 'px',
        pin: true,
        pinSpacing: false,
        scrub: true,
      },
    })

    tl.to(generalContentRow, {
      scale: 0.9,
      y: 40,
      autoAlpha: 0,
    })
  })
}
pinGeneralContent()
